import { render, staticRenderFns } from "./Reply-Comment.vue?vue&type=template&id=b043cd06&scoped=true&"
import script from "./Reply-Comment.vue?vue&type=script&lang=js&"
export * from "./Reply-Comment.vue?vue&type=script&lang=js&"
import style0 from "./Reply-Comment.vue?vue&type=style&index=0&id=b043cd06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b043cd06",
  null
  
)

export default component.exports